const SuccessToast = (title, message) => {
  window.toastr.options.closeButton = true;
  window.toastr.options.rtl = true;
  window.toastr.options.positionClass = "toast-top-center";
  window.toastr.options.progressBar = true;
  window.toastr.options.timeOut = 5000;
  window.toastr.success(message, title);
};

export default SuccessToast;
